@if (tabs?.length) {
  <div class="as-tab-container" [class.primary]="isPrimary" [class.secondary]="!isPrimary">
    <nav
      [id]="id"
      animationDuration="0"
      mat-tab-nav-bar
      [tabPanel]="tabPanel"
      [class.stretch]="isPrimary"
      [class.primary]="isPrimary"
      [class.mat-elevation-z1]="!ignoreShadow && !isPrimary">
      @for (tab of tabs; track $index) {
        @if (showTab(tab)) {
          <a
            mat-tab-link
            [class.active]="isActiveTab(tab)"
            [active]="isActiveTab(tab)"
            [routerLink]="tab.route"
            [queryParams]="tab.queryParams">
            {{ tab.name | translate: locale.language }}
          </a>
        }
      }
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  </div>
}
